module.exports = "<p>\n  project-design-issue-all-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/project-design-issue-total/project-design-issue-all-grid/project-design-issue-all-grid.component.html
// module id = ./src/app/technical/project-design-issue-total/project-design-issue-all-grid/project-design-issue-all-grid.component.html
// module chunks = main